import { XMarkIcon } from '@heroicons/react/24/outline';

type Props = {
  onClick: () => void;
};

// The in-input "X" that clears a search box, overlaid on the right of the field.
// Shared by the user/role/ACL autocompletes so they stay visually identical.
// tabIndex={-1} keeps it out of the Tab order so Tab from the input still reaches
// the results list (options use tabIndex={0}); the X remains mouse-clickable.
export default function ClearSearchButton({ onClick }: Props) {
  return (
    <button
      type="button"
      aria-label="Clear search"
      tabIndex={-1}
      className="absolute right-2 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100 focus:outline-none"
      onClick={onClick}
    >
      <XMarkIcon className="h-5 w-5" />
    </button>
  );
}
